<template>
  <div id="">
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          {{title}}
        </el-form-item>
        <el-form-item>
          <audio ref="audio" controls="controls" @pause="stopTimer" @play="startTimer" @canplay="autoPlay" :src="audioUrl" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="moveProgress(-60)">前1分钟</el-button>
          <el-button type="primary" @click="moveProgress(-10)">前10秒</el-button>
          <el-button type="primary" @click="moveProgress(10)">后10秒</el-button>
          <el-button type="primary" @click="moveProgress(60)">后1分钟</el-button>
          <el-button type="danger" @click="finishProgress()">结束</el-button>
        </el-form-item>
      </el-form>
    </el-col>

  </div>
</template>

<script>
import {loveqApi} from '../../api/index';
import {HttpResp} from '../../constant/index';

export default {
  name: 'LoveqDetail',
  data() {
    return {
      filters: {
        name: ''
      },
      timer: [],
      audioId: this.$route.query.audioId,
      audioUrl: '',
      title: "",
    }
  },
  mounted: function () {
    this.checkProtocol();
  },
  beforeDestroy: function () {
    window.clearInterval(this.timer.pop());
  },
  computed: {

  },
  methods: {
    // 检查协议
    checkProtocol() {
      // 只能http访问
      if (window.location.protocol != "http:") {
        this.$confirm('当前访问地址不是http, 是否跳转?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let httpUrl = "http:" + window.location.href.substr(window.location.protocol.length);
          window.location.href = httpUrl;
        });
      } else {
        this.loadProcess();
      }
    },
    // 获取进度
    loadProcess() {
      loveqApi.getProgressByAudioId(this.audioId).then(data => {
        if(data.code == HttpResp.SUCCUSS){
          this.audioUrl = data.data.audioUrl;
          this.title = "【" + data.data.audioDate + "】" + data.data.loveqTitle;
          this.$refs.audio.currentTime = data.data.progressSec;
          // 修改页面标题
          document.title = this.title;
        }else{
          this.$message({
            type: 'error',
            message: data.message
          });
        }
      });
    },
    // 开始定时器
    startTimer() {
      if (this.timer.length == 0) {
        this.timer.push(window.setInterval(this.updateProgressTime, 5000));
      }
    },
    // 更新进度时间
    updateProgressTime() {
      let param = {
        progress: parseInt(this.$refs.audio.currentTime),
        isFinish: this.$refs.audio.ended,
      };
      this.sendUpdateProgress(param);
    },
    // 结束节目
    finishProgress() {
      // this.$refs.audio.pause();
      let param = {
        progress: parseInt(this.$refs.audio.currentTime),
        isFinish: true,
      };
      this.sendUpdateProgress(param);
    },
    // 发送更新进度请求
    sendUpdateProgress(param) {
      loveqApi.sendUpdateProgress(this.audioId, param).then(data => {
        if(data.code == HttpResp.SUCCUSS){
          // 更新进度成功
          console.log("更新进度成功")
        }else{
          // 更新进度失败
          console.log("更新进度失败")
        }
      });
    },
    // 暂停定时器
    stopTimer() {
      this.updateProgressTime();
      window.clearInterval(this.timer.pop());
    },
    // 加载完成自动播放
    autoPlay() {
      this.$refs.audio.play();
    },
    // 调整进度
    moveProgress(sec) {
      this.$refs.audio.currentTime = this.$refs.audio.currentTime + sec;
    },
  }

}
</script>



// WEBPACK FOOTER //
// src/components/loveq/LoveqDetail.vue